import React from 'react'
import { difference } from 'lodash'

import BranchDisplay from '../BranchDisplay/BranchDisplay'
import Tooltip from '../Tooltip/Tooltip'
import { Vendor } from './types'

const getInputTagData = (vendor: Vendor, data: any, uids: any, hasBranchFeature: boolean) => {
    if (!Array.isArray(uids) || uids[0] === '$all') {
        return []
    }
    let tags: any = []
    let tempShowAsset: any = []
    const uidSet = new Set()

    // 'branch-display-dom' is UI-React dom element
    let appendToId = 'branch-display-dom'
    let branchDisplayDOM = document.getElementById('branch-display-dom')
    // Temporary element for the venus to render in Storybook
    // 'venus-branch-display-dom' is Storybook dom element
    if (!branchDisplayDOM) {
        appendToId = 'venus-branch-display-dom'
        branchDisplayDOM = document.createElement('div')
        branchDisplayDOM.id = appendToId
        document.body.appendChild(branchDisplayDOM)
        branchDisplayDOM = document.getElementById(appendToId)
    }

    data.forEach((d: any) => {
        if (uids.includes(d.uid) && !uidSet.has(d.uid)) {
            tempShowAsset.push(d.uid)
            uidSet.add(d.uid)

            // Function to normalize field to nested array structure for BranchDisplay
            const normalizeField = (field: any, isBranch = false) => {
                if (!hasBranchFeature && Array.isArray(field)) return field[0]

                // hasBranchFeature - true && isBranch - false
                if (!isBranch) {
                    return !Array.isArray(field) ? [field] : field
                }
                return field.length > 0 && !Array.isArray(field[0]) ? field.map((item: string) => [item]) : field
            }

            // Workaround for Asset Management V2 to ensure consistent array structure,
            // to support on BranchDisplay
            d = {
                ...d,
                name: normalizeField(d.name),
                filename: normalizeField(d.filename),
                title: normalizeField(d.title),
                ...(d?._branches || d?._workspaces ? { _branches: normalizeField(d?._branches || d?._workspaces || [[]], true) } : {})
            }

            tags.push({
                label: hasBranchFeature ? (
                    <Tooltip
                        content={
                            <BranchDisplay
                                moduleType={d.is_dir ? 'folder' : 'asset'}
                                moduleVal={d}
                                titleKey={d.is_dir ? 'name' : 'filename'}
                                vendor={vendor}
                            />
                        }
                        position="right"
                        showArrow={false}
                        variantType="basic"
                        appendTo={branchDisplayDOM}>
                        {Array.isArray(d.name) || Array.isArray(d.filename) || Array.isArray(d.title)
                            ? d.name[0] || d.filename[0] || d.title[0]
                            : d.title || d.name || d.filename}
                    </Tooltip>
                ) : (
                    d.name || d.filename
                ),
                value: d.uid
            })
        }
    })
    let diffAsset: any = difference(uids, tempShowAsset)
    if (diffAsset.length > 0) {
        diffAsset.map((el: any) => {
            tags.push({
                label: el,
                value: el
            })
        })
    }
    return tags
}

export { getInputTagData }
